<template>
  <div class="container">
    <div class="card">
      <div class="card-content">
       <h5 class="blue-color">{{ $t('views.navbar.manuals') }}</h5>
      </div>
      <div class="card-content grey lighten-4">
        <ul>
          <li><a target="_blank" :href="gettingStarted">POSS Online - Getting started</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      gettingStarted: require('@/assets/documents/POSS_Getting_Started.pdf')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/application/manuals.vue